import React, {useCallback} from 'react';
import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const styles = theme => ({
  csvFile: {
    paddingLeft: theme.typography.pxToRem(15)
  },
  fileImportHeaders: {
    paddingBottom: theme.typography.pxToRem(15)
  },
  fileUploadContainer: {
    padding: `${theme.typography.pxToRem(25)} 0 ${theme.typography.pxToRem(35)} ${theme.typography.pxToRem(25)}`
  },
  hideInput: {
    display: 'none'
  }
});

function CsvImportForm({ classes, file, onCsvFileChange, templateFilename, children }) {

  const handleFileChange = useCallback((event) => {
    onCsvFileChange(event.target.files[0]);
    event.target.value = null;
  })

  const downloadTemplate = useCallback((event) => {
    const a = document.createElement("a");
    a.href = `/${templateFilename}`;
    a.setAttribute("download", templateFilename);
    a.click();
  })

  const uploadComponent = (
    <Grid container rowSpacing={1} alignItems="center" className={classes.uploadCsv}>
      <Grid size={12}>
        <Typography className={classes.fileImportHeaders} variant="h6">
          CSV File
        </Typography>
      </Grid>
      <Grid size={12}>
        <Button
          color="secondary"
          component="label"
          size="small"
          variant="contained"
        >
          Upload
          <input
            className={classes.hideInput}
            accept="text/csv"
            onChange={handleFileChange}
            type="file"
          />
        </Button>
        {file !== null && (
          <Typography className={classes.csvFile} variant="h6">
            {file.name}
          </Typography>
        )}
      </Grid>
      <Grid size={12}>
        <Button
          color="secondary"
          component="label"
          size="small"
          variant="contained"
          onClick={downloadTemplate}
        >
          Download Template
        </Button>
      </Grid>
    </Grid>
  );

  if (children) {
    return (
      <Paper className={classes.fileUploadContainer}>
        <Grid container rowSpacing={3} alignItems="center">
          {children}
          <Grid size={12}>
            {uploadComponent}
          </Grid>
        </Grid>
      </Paper>
    );
  }
  else {
    return (
      <Paper className={classes.fileUploadContainer}>
        {uploadComponent}
      </Paper>
    );
  }
}

export default withStyles(CsvImportForm, styles, { withTheme: true });
